import { frontendURL } from '../../../../helper/URLHelper';
import { FEATURE_FLAGS } from '../../../../featureFlags';

import SettingsWrapper from '../SettingsWrapper.vue';
import Index from './Index.vue';
import TramiteTypeEditor from './TramiteTypeEditor.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/tramite-types'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'tramite_types_wrapper',
          meta: {
            featureFlag: FEATURE_FLAGS.TRAMITES,
            permissions: ['administrator'],
          },
          redirect: to => {
            return { name: 'tramite_types_settings_list', params: to.params };
          },
        },
        {
          path: 'list',
          name: 'tramite_types_settings_list',
          meta: {
            featureFlag: FEATURE_FLAGS.TRAMITES,
            permissions: ['administrator'],
          },
          component: Index,
        },
        {
          path: ':typeId/edit',
          name: 'tramite_types_settings_edit',
          meta: {
            featureFlag: FEATURE_FLAGS.TRAMITES,
            permissions: ['administrator'],
            fullWidth: true,
          },
          component: TramiteTypeEditor,
          props: route => ({ typeId: route.params.typeId }),
        },
      ],
    },
  ],
};
